import React from 'react'
import styled from '@emotion/styled'
import {useDefaultLayout} from 'hooks/useDefaultLayout'

import {ANIMATION_TYPES, Overlay} from '@vio/atlas/Overlay'

type Props = {
  mapComponent: React.ReactNode
}

const Wrapper = styled.main`
  display: flex;
  position: fixed;
  top: 0;
  width: 100%;
  min-height: 100%;
`

export const MapOverlay = ({mapComponent}: Props) => {
  const {isMapVisible} = useDefaultLayout()

  return (
    <Overlay
      isOpen={isMapVisible}
      shadeBackground={false}
      animationType={ANIMATION_TYPES.FADE_IN_OUT}
    >
      <Wrapper>{mapComponent}</Wrapper>
    </Overlay>
  )
}
